import { FaCheck, FaExclamationTriangle } from 'react-icons/fa';
import { AppButton } from '../Button/_index';

const BLOCK = 'LStudio__app_savebar';

/*
    🔥 BARRA DE GUARDADO

    Aparece pegada abajo cuando hay cambios sin guardar y desaparece
    sola al guardar.

    ⚠️ NO SE MONTA Y DESMONTA: SE DESLIZA

    Si apareciera de la nada, el contenido de abajo saltaría cada vez
    que el usuario toca una letra. Queda siempre en el árbol y entra
    con una transición.

    ⚠️ "DESCARTAR" VA A LA IZQUIERDA Y EN VARIANTE FANTASMA

    La acción destructiva no puede estar donde el pulgar espera
    encontrar la constructiva. Es el mismo criterio que ya usás en el
    Confirm.

    ⚠️ EL ÚLTIMO GUARDADO SE MUESTRA

    Después de guardar, la barra se va pero deja el rastro: sin eso el
    usuario no sabe si el clic entró o si la barra desapareció por
    otro motivo.
*/

export const SaveBar = ({
    bar,
    message = 'Tenés cambios sin guardar',
    saveLabel = 'Guardar cambios',
    discardLabel = 'Descartar',
    hasHotkeyHint = true,
    isFixed = true,
    extra = null,
}) => (

    <div
        className={BLOCK}
        data-open={bar.isDirty || !!bar.error}
        data-fixed={isFixed}
        role="status"
        aria-live="polite"
    >

        <div className={`${BLOCK}__inner`}>

            <span className={`${BLOCK}__message`} data-error={!!bar.error}>

                <span className={`${BLOCK}__icon`} aria-hidden="true">
                    {bar.error ? <FaExclamationTriangle /> : <FaCheck />}
                </span>

                {bar.error ?? message}

            </span>

            {extra && <div className={`${BLOCK}__extra`}>{extra}</div>}

            <div className={`${BLOCK}__actions`}>

                {
                    hasHotkeyHint && (
                        <kbd className={`${BLOCK}__kbd`}>Ctrl + S</kbd>
                    )
                }

                <AppButton variant="ghost" tone="neutral" size="sm"
                    isDisabled={bar.isSaving} onClick={bar.onDiscard} >
                    {discardLabel}
                </AppButton>

                <AppButton size="sm" isLoading={bar.isSaving} onClick={bar.onSave}>
                    {saveLabel}
                </AppButton>

            </div>

        </div>

    </div>
);

/*
    🔥 RASTRO DEL ÚLTIMO GUARDADO

    Va donde quieras —normalmente en el PageHeader—. Recibe la fecha
    ya formateada: acá no se formatean fechas.
*/
export const SaveBarStamp = ({ bar, label = 'Guardado', formatted = null }) => {

    if (!bar.savedAt) return null;

    return (
        <span className={`${BLOCK}__stamp`}>
            <FaCheck aria-hidden="true" /> {label} {formatted ?? bar.savedAt.toLocaleTimeString()}
        </span>
    );
};
